(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["coupon-panel"] && !Shopify.designMode) return;
  try {
    
(function () {
  var panel = document.getElementById('vme-coupon-panel');
  if (!panel) return;

  function applyCode(code, btn) {
    if (!code) return;
    if (btn) {
      btn.textContent = 'Applied ✓';
      btn.setAttribute('disabled', 'disabled');
    }
    // Shopify's discount URL attaches the code to the checkout session
    window.location.href = '/discount/' + encodeURIComponent(code.trim()) + '?redirect=/checkout';
  }

  // Apply buttons on coupon cards
  panel.querySelectorAll('.vme-cp__apply').forEach(function (btn) {
    btn.addEventListener('click', function () {
      applyCode(btn.getAttribute('data-cp-code'), btn);
    });
  });

  // Manual entry
  var input = document.getElementById('vme-cp-code-input');
  var manualBtn = document.getElementById('vme-cp-code-apply');
  if (manualBtn && input) {
    manualBtn.addEventListener('click', function () {
      applyCode(input.value, manualBtn);
    });
    input.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') applyCode(input.value, manualBtn);
    });
  }

  // Filter chips
  panel.querySelectorAll('.vme-cp__chip').forEach(function (chip) {
    chip.addEventListener('click', function () {
      panel.querySelectorAll('.vme-cp__chip').forEach(function (c) {
        c.classList.remove('vme-cp__chip--active');
      });
      chip.classList.add('vme-cp__chip--active');
      var f = chip.getAttribute('data-cp-filter');
      if (f === 'all') {
        panel.removeAttribute('data-cp-view');
      } else {
        panel.setAttribute('data-cp-view', f);
      }
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class MobileDisclosure extends DetailsDisclosure {
      constructor() {
        super();
        this.reset();
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
          this.querySelectorAll('.disclosure, .disclosure__title, .disclosure__panel, .disclosure__content').forEach((el) => {
            [...el.classList].filter((cl) => cl.indexOf('disclosure') === 0).forEach((cl) => {
              el.classList.remove(cl);
              el.classList.add(`mobile-${cl}`);
            });
          });
        } else {
          this.toggle.removeAttribute('tabindex');
          this.querySelectorAll('.mobile-disclosure, .mobile-disclosure__title, .mobile-disclosure__panel, .mobile-disclosure__content').forEach((el) => {
            [...el.classList].filter((cl) => cl.indexOf('mobile-disclosure') === 0).forEach((cl) => {
              el.classList.remove(cl);
              el.classList.add(cl.substr(7));
            });
          });
        }
      }
    }

    customElements.define('mobile-disclosure', MobileDisclosure);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["middle-east-page"] && !Shopify.designMode) return;
  try {
    
// FAQ accordion
document.querySelectorAll('.vme-faq__question').forEach(function(btn) {
  btn.addEventListener('click', function() {
    var item = btn.closest('.vme-faq__item');
    var isOpen = item.classList.contains('vme-faq__item--open');
    document.querySelectorAll('.vme-faq__item').forEach(function(i) {
      i.classList.remove('vme-faq__item--open');
      i.querySelector('.vme-faq__question').setAttribute('aria-expanded', 'false');
    });
    if (!isOpen) {
      item.classList.add('vme-faq__item--open');
      btn.setAttribute('aria-expanded', 'true');
    }
  });
});

// WhatsApp click tracking → dataLayer for GTM
document.querySelectorAll('a[href*="wa.me"]').forEach(function (link) {
  link.addEventListener('click', function () {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'whatsapp_click',
      link_url: link.href,
      page_location: window.location.href
    });
  });
});



// Fade-up scroll observer
if ('IntersectionObserver' in window) {
  var observer = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('vme-visible');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.1 });
  document.querySelectorAll('.vme-fade-up').forEach(function(el) { observer.observe(el); });
} else {
  document.querySelectorAll('.vme-fade-up').forEach(function(el) { el.classList.add('vme-visible'); });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'related-products'
  var productRecommendationsSection = document.querySelector(".related-products");
  if (productRecommendationsSection === null) { return; }
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", productRecommendationsSection.dataset.url);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.innerHTML = container.querySelector(".related-products").innerHTML;
    }
  };
  request.send();
};
// fetch when section reloads in editor
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].related-products')) {
    loadProductRecommendationsIntoSection();
  }
});
// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();
})();
